import { render, staticRenderFns } from "./GuardGroupList.vue?vue&type=template&id=57c25864&"
import script from "./GuardGroupList.vue?vue&type=script&lang=js&"
export * from "./GuardGroupList.vue?vue&type=script&lang=js&"
import style0 from "./GuardGroupList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports